import React from 'react'
import PropTypes from 'prop-types'
import log from 'sentry/log'

import getParsedData from 'components/pagesContent/Chat/utils/getParsedData'

import { MapLink } from '../../style.js'

const Location = ({ isMe, jsonData }) => {
  let lat
  let lon
  const locationData = getParsedData(jsonData)

  try {
    ;({ lat, lon } = locationData)
  } catch (e) {
    log.message(`Chat: lat/lon properties missing for V1.LOCATION custom type: ', ${e}`)
  }

  if (!lat || !lon) {
    // should we render some error message?
    return null
  }

  const googleMapsUrl = `https://maps.google.com/maps?q=loc:${lat},${lon}`

  return (
    <MapLink isMe={isMe} href={googleMapsUrl} target="_blank" rel="noopener noreferrer">
      {googleMapsUrl}
    </MapLink>
  )
}

Location.propTypes = {
  isMe: PropTypes.bool.isRequired,
  jsonData: PropTypes.string.isRequired,
}

export default Location
